import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import getters from "./getters";
import plugins from "vuex-persistedstate"
Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    user,
  },
  getters,
  plugins: [plugins()]
});

export default store;
